import gql from "graphql-tag"

const GET_TAX_GROUP = gql`
  query getTaxGroup($id: ID!) {
    getTaxGroup(id: $id) {
      id
      name
      description
      created
      updated
    }
  }
`

export default GET_TAX_GROUP
